import React from 'react'
import { compose, pure } from 'recompose'
import { translate } from 'react-i18next'
import styles from './togglePasswordComponent.scss'
import PropTypes from 'prop-types'
import IconShowPassword from '../../../assets/icons/iconShowPassword.svg'
import IconHidePassword from '../../../assets/icons/iconHidePassword.svg'

export function TogglePassword (props) {
  const { t } = props
  return (
    <div className={[props.wrapperStyle, styles.floatLabel].join(' ')}>
      <input
        {...props.input}
        className={[styles.srOnly, styles.inputFocus].join(' ')}
        type='checkbox'
        id={props.input.name}
      />
      <label htmlFor={props.input.name}>
        <span className={styles.srOnly}>
          {props.input.value ? t('form:hidePassword') : t('form:showPassword')}
        </span>
        {props.input.value ? <IconHidePassword /> : <IconShowPassword />}
      </label>
    </div>
  )
}

TogglePassword.propTypes = {
  wrapperStyle: PropTypes.string,
  input: PropTypes.object,
  t: PropTypes.func.isRequired
}

export default compose(translate(), pure)(TogglePassword)



// WEBPACK FOOTER //
// ./src/forms/components/togglePassword/togglePasswordComponent.js